import { DecimalPipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Order, OrdersService } from 'src/app/core/orders.service';

@Component({
  selector: 'app-orders-delete-dialog',
  templateUrl: './orders-delete-dialog.component.html',
  styleUrls: ['./orders-delete-dialog.component.scss'],
})
export class OrdersDeleteDialogComponent {
  order?: Order;
  amount: string | null;
  is_delete_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<OrdersDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private decimal_pipe: DecimalPipe,
    private orders_service: OrdersService,
    private error_service: ErrorService,
  ) {
    this.order = data.order;
    this.amount = `${this.formatNumber(data.order.amount.total)}€`;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onDeleteClick(): void {
    if (this.order?.store_id && this.order?.order_id) {
      this.deleteOrder(this.order?.store_id, this.order?.order_id);
    }
  }

  deleteOrder(store_id: string, order_id: string): void {
    this.is_delete_running = true;
    this.orders_service.delete(store_id, order_id).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_delete_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_delete_running = false;
      },
    });
  }

  formatNumber(digits: number): string | null {
    return this.decimal_pipe.transform(digits / 100, '0.2-2', 'it-IT');
  }
}
